
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { PAGE_DEFAULT_FONT_SIZE, PAGE_DEFAULT_FONT_TYPE, PAGE_DEFAULT_LAYOUT } from '@/container';
import { layoutOptions } from '@/util/book/layouts';
import { fontOptions, FontTypeOption } from '@/util/book/fonts';

@Component
export default class PageActionBar extends Vue {
    @Prop({ type: String, required: true })
    public readonly paperType!: string;

    @Prop({ type: String, required: true })
    public readonly orientation!: string;

    @Prop({ type: Number, required: true })
    public readonly pageCount!: number;

    @Prop({ type: String, required: true })
    public readonly layout!: string;

    @Prop({ type: String, required: true })
    public readonly fontType!: string;

    @Prop({ type: Number, required: true })
    public readonly fontSize!: number;

    public internalLayout = PAGE_DEFAULT_LAYOUT;
    public internalFontType = PAGE_DEFAULT_FONT_TYPE;
    public internalFontSize = PAGE_DEFAULT_FONT_SIZE;

    public layoutOptions = layoutOptions;
    public fontTypeOptions: FontTypeOption[] = [...fontOptions];

    public get fontTypeLabel(): string {
        return this.fontTypeOptions.find((t) => t.id === this.fontType)?.label || '';
    }

    public get pageClasses(): any {
        const frameClass = 'mjegb-page-frame-' + this.orientation + '-' + this.paperType;
        return {
            [frameClass]: true,
        };
    }

    public onSelectLayout(type: string): void {
        this.internalLayout = type;
    }

    public onAddPage(): void {
        this.$emit('add-page');
    }

    public onDeletePage(): void {
        this.$emit('delete-page');
    }

    @Watch('layout', { immediate: true })
    public onLayoutChanged(layout: string): void {
        if (layout !== this.internalLayout) {
            this.internalLayout = layout;
        }
    }

    @Watch('fontType', { immediate: true })
    public onFontTypeChanged(fontType: string): void {
        if (fontType !== this.internalFontType) {
            this.internalFontType = fontType;
        }
    }

    @Watch('fontSize', { immediate: true })
    public onFontSizeChanged(fontSize: number): void {
        if (fontSize !== this.internalFontSize) {
            this.internalFontSize = fontSize;
        }
    }

    @Watch('internalLayout')
    public onInternalLayoutChanged(layout: string) {
        this.$emit('configuration-changed', { layout });
    }

    @Watch('internalFontType')
    public onInternalFontTypeChanged(fontType: string) {
        this.$emit('configuration-changed', { fontType });
    }

    @Watch('internalFontSize')
    public onInternalFontSizeChanged(fontSize: number) {
        this.$emit('configuration-changed', { fontSize });
    }
}
